import { printFullNamedDate } from "./date";
import { currencySpaces } from "./processRow";

export function currencyToDbFormat(value) {
    return (value.replace(/\s/g, "") * 10000).toFixed();
}

export function currencyToUiFormat(value) {
    value = (value / 10000).toFixed(2);
    const [i, f] = value.toString().split(".");
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "." + f;
}

export function printColumnValue(value, column = {}) {
    if ( value == null || value === false || value === true ) {
        return String(value);
    }
    if (
        column.type === "timestamp without time zone"
        || /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z?/.test(value)
    ) {
        return printFullNamedDate(value);
    }
    if ( typeof value === "number" || String(column.type).startsWith("numeric") ) {
        if ( value === 0 ) {
            return "0";
        }
        return currencySpaces(value, { float: "auto" });
    }
    if ( typeof value === "string" ) {
        return value;
    }

    return JSON.stringify(value, null, 4);
}